export default {
  path: '',
  name: 'layoutLogin',
  component: () => import('../components/login/Layout'),
  redirect: { name: 'Login' },
  meta: {
    breadcrumb: 'global.login',
  },
  children: [
    {

      name: 'Login',
      path: '/login',
      component: () => import('../views/login/Login'),
      meta: {
        breadcrumb: 'global.login',
      },

    },
    {
      name: 'ForgotPassword',
      path: '/ForgotPassword',
      component: () => import('../views/login/ForgotPassword'),
      meta: {
        breadcrumb: 'global.login',
      },
    },
    {
      name: 'PasswordTurnover',
      path: '/PasswordTurnover',
      component: () => import('../views/login/PasswordTurnover'),
      meta: {
        breadcrumb: 'global.login',
      },
    },
    {
      name: 'RegenPassword',
      path: '/RegenPassword/:id/:token',
      component: () => import('../views/login/RegenPassword'),
      meta: {
        breadcrumb: 'global.login',
      },
    }
  ]
};
